module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/circleCheck_UB.30894ab4.svg";